import React, { useState, useEffect } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
    validateNegativeValues,
    validateEmptySpaces,
} from "../../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState("");

    useEffect(() => {
        if (props.editable) {
            reset({ ...props.editable });
            setbase64(props.editable.image);
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const handleChange = (file) => {
        let max = 2 * 1024 * 1024;
        if (file.size > max) {
            alert("max file size should be less than 2mb");
            return;
        }
        if (file.type === "image/png" || file.type === "image/jpeg") {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                setbase64(reader.result);
                setValue("img", reader.result);
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        } else {
            alert("please upload image in PNG and JPEG format ");
        }
    };

    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );
    const onSubmit = (data) => {
        if (!props.editable) {
            Services.AddCategory("POST", JSON.stringify(data), token)
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/omnimart-categories?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories();

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else if (props.editable) {
            Services.updateCategory(
                "PUT",
                JSON.stringify(data),
                token,
                props.editable.categoryId
            )
                .then((res) => {
                    if (res.Status === 1) {
                        props.setmodal(false);
                        Navigate(`/omnimart-categories?page=${1}`);
                        props.setpageCount(1);
                        props.tableload(true);
                        props.getCategories();
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable
                                ? "Update Category"
                                : "Add Category"}
                        </h3>
                        <p>
                            {props.editable
                                ? "Update Category"
                                : "Add Category"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Category Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                disabled={props.editable}
                                {...register("name", {
                                    required: "category Name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.name && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.name?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Category Icon</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["uploaded-img"]}>
                        <img src={base64} alt="" width={"120px"} />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Priority</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("priority", {
                                    required: "priority is required",
                                    validate: validateNegativeValues,
                                })}
                            />
                            {errors?.priority && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.priority?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Description</label>
                        <div className={dashboardclasses["select"]}>
                            <textarea
                                name=""
                                id=""
                                {...register("description", {
                                    required: "description is required",
                                    validate: validateEmptySpaces,
                                })}></textarea>
                            {errors?.description && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.description?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Category"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
